const footerNavigations = document.querySelectorAll('.footer-navigation')

const normaliseFooterPath = (value) => {
  const path = new URL(value, window.location.origin).pathname
  return path === '/' ? path : path.replace(/\/$/, '')
}

footerNavigations.forEach((footerNavigation) => {
  footerNavigation.querySelectorAll('.footer-navigation-column__link').forEach((link) => {
    if (normaliseFooterPath(link.href) !== normaliseFooterPath(window.location.href)) return
    link.classList.add('is-active')
    link.setAttribute('aria-current', 'page')
  })

  const footerNavigationColumns = footerNavigation.querySelectorAll(
    '.footer-navigation-column'
  )

  footerNavigationColumns.forEach((column) => {
    const target = column.querySelector('.footer-navigation-column__title')

    if (!target) {
      return
    }
    target.addEventListener('click', () => {
      // Check if we are on mobile which is below 985px
      if (window.innerWidth > 985) {
        return
      }

      column.classList.toggle('footer-navigation-column--active')
    })
  })
})

const footerBottomNavigation = document.querySelector(
  '.js-footer-bottom-navigation'
)

if (footerBottomNavigation) {
  const toggle = footerBottomNavigation.querySelector(
    '.js-footer-bottom-navigation-toggle'
  )
  const links = footerBottomNavigation.querySelector(
    '.js-footer-bottom-navigation-links'
  )

  if (toggle && links) {
    footerBottomNavigation.classList.add('footer-bottom-navigation--enhanced')

    const setOpen = (isOpen) => {
      footerBottomNavigation.classList.toggle(
        'footer-bottom-navigation--active',
        isOpen
      )
      toggle.setAttribute('aria-expanded', isOpen.toString())
    }

    toggle.addEventListener('click', () => {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true')
    })

    footerBottomNavigation.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        setOpen(false)
        toggle.focus()
      }
    })
  }
}

const cookieSettingsLinks = document.querySelectorAll(
  'a[href$="#cookie-settings"]'
)

cookieSettingsLinks.forEach((link) => {
  link.addEventListener('click', (event) => {
    event.preventDefault()

    if (window.Cookiebot && typeof window.Cookiebot.renew === 'function') {
      window.Cookiebot.renew()
    }
  })
})

const footerNewsletterForms = document.querySelectorAll(
  '.js-footer-newsletter-form'
)

footerNewsletterForms.forEach((form) => {
  const section = form.closest('.footer-newsletter')
  const title = form.querySelector('.footer-newsletter__title')
  const submitButton = form.querySelector('.footer-newsletter__submit')
  const status = form.querySelector('.footer-newsletter__status')

  if (
    !section ||
    !title ||
    !submitButton ||
    !status ||
    typeof window.fetch !== 'function'
  ) {
    return
  }

  const submitButtonLabel = submitButton.textContent

  const resetErrorState = () => {
    submitButton.classList.remove('footer-newsletter__submit--error')
    submitButton.textContent = submitButtonLabel

    if (status.classList.contains('footer-newsletter__status--error')) {
      setStatus('', '')
    }
  }

  const setStatus = (message, type) => {
    status.textContent = message
    status.classList.toggle(
      'footer-newsletter__status--error',
      type === 'error'
    )
  }

  form.addEventListener('input', resetErrorState)

  form.addEventListener('submit', (event) => {
    event.preventDefault()

    if (form.getAttribute('aria-busy') === 'true') {
      return
    }

    if (!form.checkValidity()) {
      form.reportValidity()
      return
    }

    resetErrorState()
    setStatus('', '')
    form.setAttribute('aria-busy', 'true')
    submitButton.disabled = true

    window
      .fetch(form.action || window.location.href, {
        body: new FormData(form),
        cache: 'no-store',
        credentials: 'same-origin',
        method: 'POST',
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Newsletter sign-up returned ${response.status}`)
        }

        form.reset()
        section.classList.add('footer-newsletter--success')
        title.textContent = form.dataset.successMessage
        title.focus()

        const fadeDuration = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches
          ? 0
          : 300

        window.setTimeout(() => {
          section.classList.add('footer-newsletter--success-complete')
        }, fadeDuration)
      })
      .catch(() => {
        setStatus(form.dataset.errorMessage, 'error')
        submitButton.classList.add('footer-newsletter__submit--error')
        submitButton.textContent = form.dataset.errorButtonLabel
        status.focus()
      })
      .then(() => {
        form.removeAttribute('aria-busy')
        submitButton.disabled = false
      })
  })
})
